import { render, staticRenderFns } from "./FilesAndAttachments.vue?vue&type=template&id=c07682fc"
import script from "./FilesAndAttachments.vue?vue&type=script&lang=js"
export * from "./FilesAndAttachments.vue?vue&type=script&lang=js"
import style0 from "./FilesAndAttachments.vue?vue&type=style&index=0&id=c07682fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports